import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { ConvexAuthProvider } from "@convex-dev/auth/react";
import { ConvexProvider } from "convex/react";
import { HelmetProvider } from "react-helmet-async";
import { convex } from "@/lib/convex";
import { routeTree } from "@/app/routeTree.gen";
import "@/app/index.css";

// Inicializar i18n (debe estar antes de cualquier componente React)
import "@/lib/i18n";

// Create router instance
const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
});

// Register router for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Get root element
const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

// Prevent multiple React root creations using a global flag
// This can happen during HMR in development
declare global {
  interface Window {
    __REACT_ROOT_CREATED__?: boolean;
  }
}

if (!window.__REACT_ROOT_CREATED__) {
  // Create and render app
  const root = createRoot(rootElement);

  root.render(
    <StrictMode>
      {/* AuthErrorBoundary desactivado temporalmente para debugging */}
      <HelmetProvider>
        <ConvexProvider client={convex}>
          <ConvexAuthProvider client={convex}>
            <RouterProvider router={router} />
          </ConvexAuthProvider>
        </ConvexProvider>
      </HelmetProvider>
    </StrictMode>,
  );

  // Mark that we've created the root
  window.__REACT_ROOT_CREATED__ = true;
} else {
  console.warn("React root already created. Skipping createRoot() call");
}
